import React from 'react';
import 'styles/components/menu/business/ElectronicWarfareTab.scss';
import img from 'assets/images/business/voice_recognition_system.png';
import styled from 'styled-components';

const Img = styled.div`
    width: 100%;
    height: 0;
    padding-top: calc(540 / 1508 * 100%);
    background : url(${img}) center left / cover no-repeat;
`;

const ElectronicWarfareTab = () => {
    return (
        <section className='ElectronicWarfareTab'>
            <div className="ElectronicWarfareTab-wrapper">
                <div className='title'>
                    다양한 국방사업 경험과 <br className='lineBreak pc' />
                    <span className='fw_bold'>IT 신기술을 접목</span>하여
                    <br className='lineBreak' />
                    <span className='fw_bold'>전자전 사업을 수행</span>하고 있습니다
                </div>
                <div className="content">
                    <div className="content-title">전자전</div>
                    <div className="content-text">
                        전자전은 전장환경에서 <span className='fw_bold'>위협 전파신호를 탐지∙추적∙분석∙감청</span>하여 아군에게 전파하고 수집된 정보를 이용하여 <span className='fw_bold'>아군을 보호</span>하며, <br className='lineBreak pc' />
                        <span className='fw_bold'> 적의 통신망을 교란</span>시켜 아군의 성공적인 작전 수행을 가능하게 하는 무기체계입니다.<br className='lineBreak' />
                        어질인소프트는 <span className='fw_bold'>전술전자전(지상용) SW 성능 극대화</span>를 위한 마이그레이션 및 정보 분석 지원을 위한 <span className='fw_bold'>AI 기술 적용</span> 등 <br className='lineBreak pc' />
                        전자전 무기체계의 품질 및 성능 향상에 기여하고 있습니다.
                    </div>
                    <div className="circles">
                        <div className="circle-wrapper">
                            <div className="circle circle1">
                                <p>ES</p>
                                <p>(Electronic Warfare Support)</p>
                            </div>
                            <div className="circle-content">
                                적 무선통신 및 전자장비로부터 <br className='lineBreak' />
                                방사되는 전자파를 수집, 처리, <br className='lineBreak' />
                                분석하여 정보를 생산
                            </div>
                        </div>
                        <div className="circle-wrapper">
                            <div className="circle circle2">
                                <p>EA</p>
                                <p>(Electronic Attack)</p>
                            </div>
                            <div className="circle-content">
                                적 통신을 방해하거나, <br className='lineBreak' />
                                무력화시키기 위해 <br className='lineBreak' />
                                전자파를 직접 방사
                            </div>
                        </div>
                        <div className="circle-wrapper">
                            <div className="circle circle3">
                                <p>EP</p>
                                <p>(Electronic Protection)</p>
                            </div>
                            <div className="circle-content">
                                적 전자파 위협으로부터 <br className='lineBreak' />
                                아군의 전자파 사용을 <br className='lineBreak' />
                                보호하는 활동
                            </div>
                        </div>
                    </div>
                    <div className="plus">
                        <div className="plus-h"></div>
                        <div className="plus-v"></div>
                    </div>
                    <div className="img-wrapper">
                        <Img />
                        {/* <div className="img-content">
                            <p className="img-title">STT 개요</p>
                            <div className="img-text">
                                운용의 편리성을 고려한 엣지구성 패키지는 독립된 환경에서의 운용이 필요한<span className='fw_bold'> 전장환경에서 최적의 성능 발휘</span><br className='lineBreak' />
                                음성인식을 수행하는 환경은<span className='fw_bold'> 네트워크 비접속 실행 환경을 제공</span>하며, 휴대 및 이동이 편리한 장점 보유
                            </div>
                        </div> */}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ElectronicWarfareTab;